import { makeStyles } from "@material-ui/core/styles";

const Style = makeStyles((theme) => ({
  root: {
    height: "80vh",
  },
  content: {
    padding: theme.spacing(0, 3),
    textAlign: "center",

    "& h5": {
      fontSize: 18,
    },
    "& img": {
      height: 320,
    },
  },
}));

export default Style;
